import { useEffect, useState } from "react";
import {
  CaretDownOutlined,
  WarningOutlined,
  CaretRightOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";
import { get } from "../Libraries/Ajax/HttpService";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { useRef } from "react";
import Highlighter from "react-highlight-words";
import { DatePicker, Space, Badge } from "antd";
// import { useHistory } from 'react-router-dom';
import { useNavigate,useLocation, } from "react-router-dom";

import { Card, Table } from "antd";
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  Tooltip,
  LineChart,
  ResponsiveContainer,
} from "recharts";
import axios from "axios";
import { Collapse, theme } from "antd";
import back from "../assets/images/back.svg";
import redArrow from "../assets/images/red-arrow.svg";
import greenArrow from "../assets/images/green-arrow.svg";
import { useDistrict } from "../utils/DistrictContext";
const { Panel } = Collapse;

function FlowHealth() {
  const [reverse, setReverse] = useState(false);
  const [reversetwo, setReversetwo] = useState(false);
  const [reversethree, setReversethree] = useState(false);

  const [selected, setSelected] = useState("week");
  const [loading, setloading] = useState(true);
  const [datas, setdatas] = useState([]);
  const [datass, setdatass] = useState([]);
  const [datasss, setdatasss] = useState([]);
  const selectedDistrict = useDistrict();
  const { RangePicker } = DatePicker;
  // let history = useHistory();
  const location = useLocation();
  const navigate = useNavigate();
  // const { token } = theme.useToken();
  const panelStyle = {
    marginBottom: 24,
    // background: token.colorFillAlter,
    // borderRadius: token.borderRadiusLG,
    border: "none",
  };
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const initialKey = location.state?.activeKey || "1";
  const [activeKey, setActiveKey] = useState(initialKey);

  // Update activeKey if the user navigates here again with a different state
  useEffect(() => {
    if (location.state?.activeKey) {
      setActiveKey(location.state.activeKey);
    }
  }, [location.state]);

  const onChangekey = (key) => {
    setActiveKey(key);
  };
  

  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button type="link" size="small" onClick={close}>
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    filterDropdownProps: {
      onOpenChange: (visible) => {
        if (visible) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Account ID",
      dataIndex: "account_id",
      key: "account_id",
      width: "9%",
      ...getColumnSearchProps("account_id", "Account ID"),
    },

    {
      title: "Account Name",
      dataIndex: "overided_name",
      key: "overided_name",
      width: "12%",
      ...getColumnSearchProps("overided_name", "Account Name"),
    },
    {
      title: "Meter Type",
      dataIndex: "name",
      key: "name",
      width: "9%",
      ...getColumnSearchProps("name", "Meter Type"),
    },
    {
      title: "Meter ID",
      dataIndex: "meter_id",
      key: "meter_id",
      width: "8%",
      ...getColumnSearchProps("meter_id", "Meter ID"),
    },
    {
      title: "Register",
      dataIndex: "register_number",
      key: "register_number",
      width: "8%",
    },
    
    {
      title: "Previous Week usage",
      // dataIndex: 'pre_week',
      key: "pre_week",
      width: "16%",
      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.pre_week_range}</a>
          <br />
          <a>{record.pre_week}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },
    {
      title: "This Week usage",
      // dataIndex: 'pre_week',
      key: "week",
      width: "16%",
      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.week_range}</a>
          <br />
          <a>{record.week}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },

    {
      title: "",
      dataIndex: "percentage_arrow_down",
      key: "percentage_arrow_down",
      width: "10%",
      align: "center",
      // render: (percentage_arrow_down) => percentage_arrow_down === true ? <ArrowDownOutlined style={{ fontSize: '38px', backgroundColor: '#99e699' }} /> : <ArrowUpOutlined style={{ fontSize: '38px', backgroundColor: '#d13838' }} />
      render: (percentage_arrow_down) =>
        percentage_arrow_down === true ? (
          <img src={greenArrow} alt="" style={{ width: "50px" }} />
        ) : (
          <img src={redArrow} alt="" style={{ width: "50px" }} />
        ),
    },
    {
      title: "Message",
      dataIndex: "leak_message",
      key: "leak_message",
      width: "17%",
      render: (_, record) => (
        <>
          {" "}
          {record.leak_message ? (
            <div className="circleredbadge">
              <a>{record.leak_message}</a>
              <br />
            </div>
          ) : (
            ""
          )}
          {record.backflow_message ? (
            <div className="circleredbadge">
              <a>{record.backflow_message}</a>
            </div>
          ) : (
            ""
          )}{" "}
        </>
      ),
    },
  ];
  const columnss = [
    {
      title: "Account ID",
      dataIndex: "account_id",
      key: "account_id",
      width: "9%",
      ...getColumnSearchProps("account_id", "Account ID"),
    },

    {
      title: "Account Name",
      dataIndex: "overided_name",
      key: "overided_name",
      width: "11%",
      ...getColumnSearchProps("overided_name", "Account Name"),
    },
    {
      title: "Meter Type",
      dataIndex: "name",
      key: "name",
      width: "10%",
      ...getColumnSearchProps("name", "Meter Type"),
    },
    {
      title: "Meter ID",
      dataIndex: "meter_id",
      key: "meter_id",
      width: "8%",
      ...getColumnSearchProps("meter_id", "Meter ID"),
    },
    {
      title: "Register",
      dataIndex: "register_number",
      key: "register_number",
      width: "8%",
    },
   
    {
      title: "Previous Week usage",
      // dataIndex: 'pre_week',
      key: "pre_week",
      width: "16%",
      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.pre_week_range}</a>
          <br />
          <a>{record.pre_week}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },
    {
      title: "This Week usage",
      // dataIndex: 'pre_week',
      key: "week",
      width: "16%",
      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.week_range}</a>
          <br />
          <a>{record.week}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },
    {
      title: "",
      dataIndex: "percentage_arrow_down",
      key: "percentage_arrow_down",
      width: "10%",
      align: "center",
      render: (percentage_arrow_down) =>
        percentage_arrow_down === true ? (
          <img src={greenArrow} alt="" style={{ width: "50px" }} />
        ) : (
          <img src={redArrow} alt="" style={{ width: "50px" }} />
        ),
    },
    {
      title: "Message",
      dataIndex: "leak_message",
      key: "leak_message",
      width: "17%",
      render: (_, record) => (
        <>
          {" "}
          {record.leak_message ? (
            <div className="circleredbadge">
              <a>{record.leak_message}</a>
              <br />
            </div>
          ) : (
            ""
          )}
          {record.backflow_message ? (
            <div className="circleredbadge">
              <a>{record.backflow_message}</a>
            </div>
          ) : (
            ""
          )}{" "}
        </>
      ),
    },
  ];
  const columnsss = [
    {
      title: "Account ID",
      dataIndex: "account_id",
      key: "account_id",
      width: "9%",
      ...getColumnSearchProps("account_id", "Account ID"),
    },
    // {
    //     title: 'Message',
    //     dataIndex: 'leake_message',
    //     key: 'leake_message',
    // },
    {
      title: "Account Name",
      dataIndex: "overided_name",
      key: "overided_name",
      width: "11%",
      ...getColumnSearchProps("overided_name", "Account Name"),
    },
    {
      title: "Meter Type",
      dataIndex: "name",
      key: "name",
      width: "12%",
      ...getColumnSearchProps("name", "Meter Type"),
    },
    {
      title: "Meter ID",
      dataIndex: "meter_id",
      key: "meter_id",
      width: "10%",
      ...getColumnSearchProps("meter_id", "Meter ID"),
    },
    {
      title: "Register",
      dataIndex: "register_number",
      key: "register_number",
      width: "8%",
    },
    
    {
      title: "Previous Week usage",
      // dataIndex: 'pre_week',
      key: "pre_week",
      width: "16%",
      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.pre_week_range}</a>
          <br />
          <a>{record.pre_week}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },
    {
      title: "This Week usage",
      // dataIndex: 'pre_week',
      key: "week",
      width: "16%",
      render: (_, record) => (
        // <Space size="middle">
        <>
          <a> {record.week_range}</a>
          <br />
          <a>{record.week}</a>
          <br />
          <a>{record.unit}</a>
        </>

        // </Space>
      ),
    },

    {
      title: "",
      dataIndex: "percentage_arrow_down",
      key: "percentage_arrow_down",
      width: "6%",
      align: "center",
      // render: (percentage_arrow_down) => percentage_arrow_down === true ? <ArrowDownOutlined style={{ fontSize: '38px', backgroundColor: '#99e699' }} /> : <ArrowUpOutlined style={{ fontSize: '38px', backgroundColor: '#d13838' }} />
      render: (percentage_arrow_down) =>
        percentage_arrow_down === true ? (
          <img src={greenArrow} alt="" style={{ width: "50px" }} />
        ) : (
          <img src={redArrow} alt="" style={{ width: "50px" }} />
        ),
    },
    {
      title: "Message",
      dataIndex: "leak_message",
      key: "leak_message",
      width: "17%",
      render: (_, record) => (
        <>
          {" "}
          {record.leak_message ? (
            <div className="circleredbadge">
              <a>{record.leak_message}</a>
              <br />
            </div>
          ) : (
            ""
          )}
          {record.backflow_message ? (
            <div className="circleredbadge">
              <a>{record.backflow_message}</a>
            </div>
          ) : (
            ""
          )}{" "}
        </>
      ),
    },
  ];

  const onChange = (key) => {
    console.log(key);
  };

  const onMouseClick = (event) => {
    setSelected(event.target.value);
    console.log(selected);
  };

  const onTableClick = (event) => {
    setReverse(!reverse);
  };

  const onTabletwoClick = (event) => {
    setReversetwo(!reversetwo);
  };
  const onTablethreeClick = (event) => {
    setReversethree(!reversethree);
  };
  const onRedirection = (event) => {
    // history.push('/dashboard');
    // window.history.back();
    navigate(-1);
  };

  

  useEffect(() => {
    const fetchFlowHealthData = async () => {
      try {
        setloading(true);
        const response = await get("apis/flow_health");

        const flowData = response?.data?.data?.flow_data;
        console.log("flowData::", flowData);

        setdatas(flowData?.leak);
        setdatass(flowData?.backflow);
        setdatasss(flowData?.no_recent_flow);
      } catch (e) {
        console.error("Error fetching system battery data:", e);
      } finally {
        setloading(false);
      }
    };
    fetchFlowHealthData();
  }, [selectedDistrict?.selectedDistrict]);

  return (
    <>
      <Header />
      <Main>
        <div className="d-flex justify-content-between align-items-center mb-4">
          {/* <h4 className="mb-0"><ArrowLeftOutlined onClick={onRedirection} />  Flow Health</h4> */}

          <div className="d-flex align-items-center ">
            {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
            <img
              src={back}
              alt=""
              style={{ width: "10px", cursor: "pointer" }}
              onClick={onRedirection}
            />
            <h3 className="mb-0 ms-3">Flow Health</h3>
          </div>
         
        </div>

        <div className="bottom-layout tableLayout flow-height">
          <Card variant="borderless">
           

            <Collapse
              bordered={false}
              activeKey={activeKey} // Controlled component for direct navigation
              onChange={onChangekey}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
              className="selectAccordian"
              // onChange={onChange}
              items={[
                {
                  key: "1",
                  label: "Leak Detected",
                  children: (
                    <Table
                      columns={columns}
                      dataSource={datas}
                      className="styleRemove svg-box outliers-sty flow-dropdown"
                      pagination={{
                        defaultPageSize: 20, // Set your default pagination size here
                        pageSizeOptions: ["10", "20", "30"], // Optional: Specify additional page size options
                      }}
                      columnWidth={10}
                      loading={loading}
                      scroll={{ x: 800, y: 580 }}
                    />
                  ),
                },
                {
                  key: "2",
                  label: "Backflow",
                  children: (
                    <Table
                      columns={columnss}
                      dataSource={datass}
                      className="styleRemove svg-box outliers-sty flow-dropdown"
                      pagination={{
                        defaultPageSize: 20, // Set your default pagination size here
                        pageSizeOptions: ["10", "20", "30"], // Optional: Specify additional page size options
                      }}
                      columnWidth={10}
                      loading={loading}
                      scroll={{ x: 800, y: 580 }}
                    />
                  ),
                },
                {
                  key: "3",
                  label: "No Recent Flow",
                  children: (
                    <Table
                      columns={columnsss}
                      dataSource={datasss}
                      className="styleRemove svg-box outliers-sty flow-dropdown"
                      pagination={{
                        defaultPageSize: 20, // Set your default pagination size here
                        pageSizeOptions: ["10", "20", "30"], // Optional: Specify additional page size options
                      }}
                      columnWidth={10}
                      loading={loading}
                      scroll={{ x: 800, y: 580 }}
                    />
                  ),
                },
              ]}
            />
          </Card>
        </div>
      </Main>
    </>
  );
}

export default FlowHealth;
